export default "__VITE_ASSET__396bca20__"